import * as React from 'react'
import './OrderDetailModal.scss'
import {PrimaryButton} from "../../components/CustomUIComp/CustomFormElem";
import {connect} from "react-redux";
import {ActionType, CHAINTYPES, orderDetailType, PAY_STATUS, reducerStoreType, selectWalletType} from "../../reducers/types";
import {Dispatch} from "redux";
import alipayImg from '../../images/alipay.svg';
import wechatImg from '../../images/wechatpay.svg';
import alipayPlusImg from '../../images/alipayplus.svg';
import appleImg from '../../images/apple.svg';
import googleImg from '../../images/google.svg';
import creditCardImg from '../../images/card.svg';
import {injectIntl, IntlShape} from "react-intl";
import Grid from "@material-ui/core/Grid";

interface IProps {
    openOrderNo: string,
    orderDetail: orderDetailType,
    chainType: CHAINTYPES,
    orderType: number,
    dispatch: Dispatch<ActionType<any>>,
    onRefund: () => void,
    intl: IntlShape,
    orderAmt: number,
    selectWallet: selectWalletType,
    manual?: boolean
}

interface IState {
}

const walletIcons: { [key: string]: any } = {
    'Alipay': alipayImg,
    'Wechat': wechatImg,
    'AlipayPlus': alipayPlusImg,
    'ApplePay': appleImg,
    'GooglePay': googleImg,
    'CreditCard': creditCardImg
}

class OrderDetailModal extends React.Component<IProps, IState> {

    componentDidMount() {
        // this.props.dispatch({
        //     type: 'GET_ORDERS', payload: {
        //         type: 'detail', data: {
        //             orderNo: this.props.openOrderNo,
        //             flag: this.props.manual ? 1 : 0
        //         }
        //     }
        // })
    }

    getWalletLogo = (wallet: string) => {
        const walletInfo = this.props.selectWallet[wallet];
        if (walletInfo && walletInfo.logo) {
            return walletInfo.logo;
        }
        return walletIcons[wallet] || null;
    }

    getStatus = (status: number, partialRefund: boolean) => {
        let {intl} = this.props
        switch (status) {
            case PAY_STATUS.UNPAID:
                return intl.formatMessage({id: 'unpaid'})
            case PAY_STATUS.PAY_SUCCESS:
                if (partialRefund) {
                    return intl.formatMessage({id: 'partialRefunded'})
                }
                return intl.formatMessage({id: 'paySucc'})
            case PAY_STATUS.PAY_FAIL:
                return intl.formatMessage({id: 'transFailed'})
            case PAY_STATUS.REFUNDED:
                return intl.formatMessage({id: 'refunded'})
            case PAY_STATUS.CANCELLED:
                return intl.formatMessage({id: 'cancelled'})
            default:
                return ''
        }
    }

    public render() {
        let {orderDetail, intl} = this.props
        const walletLogo = this.getWalletLogo(orderDetail.wallet);
        return (<div className="orderDetail">
                <div className="top">
                    <div className="amt">
                        {walletLogo ? (
                            <img src={walletLogo} className="walletIcon" alt={orderDetail.wallet} style={{width: '24px', height: '24px'}}/>
                        ) : (
                            <span className="walletName">{this.props.selectWallet[orderDetail.wallet]?.name || orderDetail.wallet}</span>
                        )}
                        <span>{orderDetail.currency} {this.props.orderType ? '-' : '+'}{this.props.orderAmt || orderDetail.tradeAmt}</span>
                    </div>
                    <div className="status">{this.props.orderType ? intl.formatMessage({id: 'refundSucc'})
                        : intl.formatMessage({id: 'paySucc'})}</div>
                </div>
                <div className="content">
                    <Grid container spacing={1}>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'storeName'})}:</label>
                            {this.props.chainType === CHAINTYPES.CHAIN_STORE ?
                                <span>{orderDetail.storeName}</span> :
                                <span>{orderDetail.merchantName}</span>}
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'payTime'})}:</label>
                            <span>{orderDetail.tradeTime}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'orderNo'})}:</label>
                            <span>{orderDetail.orderNo}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'status'})}:</label>
                            <span>{this.getStatus(orderDetail.status, orderDetail.canRefundAmt < orderDetail.tradeAmt)}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'CASHIER'})}:</label>
                            <span>{orderDetail.cashierName || '-'}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'collectAmt'})}({orderDetail.currency}):</label>
                            <span>{orderDetail.tradeAmt}</span>
                        </Grid>
                        {orderDetail.exchangeFlag ?
                            <Grid item xs={6} className="orderAttr">
                                <label>{intl.formatMessage({id: 'collectAmt'})}({orderDetail.orgCurrency}):</label>
                                <span>{orderDetail.orgTradeAmt}</span>
                            </Grid> : null}
                        {orderDetail.exchangeFlag ?
                            <Grid item xs={6} className="orderAttr">
                                <label>{intl.formatMessage({id: 'exchangeRate'})}:</label>
                                <span>{`1${orderDetail.currency} ≈ ${orderDetail.exchangeRate}${orderDetail.orgCurrency}`}</span>
                            </Grid> : null}
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'remark'})}:</label>
                            <span>{orderDetail.tradeSummary}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'refundAmt'})}:</label>
                            <span>{(orderDetail.tradeAmt - orderDetail.canRefundAmt).toFixed(2)}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'payNo'})}:</label>
                            <span>{orderDetail.payOrderNo}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'partnerNo'})}:</label>
                            <span>{orderDetail.partnerOrderNo}</span>
                        </Grid>
                    </Grid>
                </div>
                {orderDetail.canRefundAmt > 0 ?
                    <div className="buttonLine">
                        <PrimaryButton
                            onClick={this.props.onRefund}>{intl.formatMessage({id: 'refund'})}</PrimaryButton>
                    </div> : null}
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        orderDetail: state.orderDetail,
        chainType: state.merchant.merchantInfo.chainType,
        selectWallet: state.merchant.merchantInfo.selectWallet
    }
})(OrderDetailModal))